import { useState, useEffect, useMemo } from 'react'
import { Scrollbars, EasyImg, FormPage } from 'src/components'
import { $api } from 'src/plugins'
import { getSingleRule } from 'src/utils/common'

const AuthInfo = (props: { record: any }) => {
  const [appInfo, setAppInfo] = useState<any>()
  useEffect(() => {
    $api['op028/getAppInfoByAdmin']({
      AppId: props.record.ID
    }).then(res => {
      res && setAppInfo(res)
    })
  }, [])

  const [pcInfo, setPCInfo] = useState<any>()
  useEffect(() => {
    $api['op028/getPCLastVersionInfo']({
      AppCode: props.record.CODE
    }).then(res => {
      res && setPCInfo(res)
    })
  }, [])

  const [mobileInfo, setMobileInfo] = useState<any>()
  useEffect(() => {
    $api['op028/getMobileLastVersionInfo']({
      AppCode: props.record.CODE
    }).then(res => {
      res && setMobileInfo(res)
    })
  }, [])

  const [authInfo, setAuthInfo] = useState<any>()
  useEffect(() => {
    $api['op028/getInstallCountInfo']({
      AppCode: props.record.CODE
    }).then(res => {
      res && setAuthInfo(res)
    })
  }, [])

  const formData = useMemo(() => {
    return {
      filterGroup: {
        Rules: [getSingleRule('AppCode', 1, props.record.CODE, true)]
      }
    }
  }, [props.record.CODE])

  return (
    <div className='op028__info'>
      <div className='op028__info-left'>
        <div className='left-header'>
          <EasyImg src={appInfo?.Icon} />
          <span>{`${appInfo?.AppName}(${appInfo?.AppCode || props.record.CODE})`}</span>
        </div>
        <div className='left-app'>
          <div className='left-app__header'>
            <EasyImg src={require('enasops/assets/op/028/pc.png')} />
            <div>
              <p>PC端版本：V{pcInfo?.Version || '--'}</p>
              <span>{pcInfo?.PublishTime || '--'}</span>
            </div>
          </div>
          <p className='left-app__version'>版本内容</p>
          <div className='left-app__detail'>
            <Scrollbars autoHide>
              <p>{pcInfo?.Content || '暂无'}</p>
            </Scrollbars>
          </div>
        </div>
        <div className='left-app'>
          <div className='left-app__header'>
            <EasyImg src={require('enasops/assets/op/028/mobile.png')} />
            <div>
              <p>移动端版本：V{mobileInfo?.Version || '--'}</p>
              <span>{mobileInfo?.PublishTime || '--'}</span>
            </div>
          </div>
          <p className='left-app__version'>版本内容</p>
          <div className='left-app__detail'>
            <Scrollbars autoHide>
              <p>{mobileInfo?.Content || '暂无'}</p>
            </Scrollbars>
          </div>
        </div>
      </div>
      <div className='op028__info-right'>
        <p className='right-title'>授权情况</p>
        <div className='right-total'>
          <div className='right-total__item'>
            <EasyImg src={require('enasops/assets/op/028/total-user.png')} />
            <p className='total'>{authInfo?.TotalTenantCount}</p>
            <span>总租户数</span>
          </div>
          <div className='right-total__item'>
            <EasyImg src={require('enasops/assets/op/028/valid-user.png')} />
            <p className='valid'>{authInfo?.EnableTenantCount}</p>
            <span>启用租户数</span>
          </div>
          <div className='right-total__item'>
            <EasyImg src={require('enasops/assets/op/028/disabled-user.png')} />
            <p className='disabled'>{authInfo?.DisableTenantCount}</p>
            <span>禁用租户数</span>
          </div>
          <div className='right-total__item'>
            <EasyImg src={require('enasops/assets/op/028/full-user.png')} />
            <p className='full'>{authInfo?.TotalUserCount}</p>
            <span>用户总数</span>
          </div>
        </div>
        <div className='right-table'>
          <FormPage formCode='OP082' formData={formData} />
        </div>
      </div>
    </div>
  )
}

export default AuthInfo